import { makePalette } from '@saas/lib/shared-utils'

export const palette = makePalette({
    error: {
        500: '#e61942',
    },
    lightGrey: {
        500: '#EBEEF5',
        600: '#dde3e3',
    },
    surface: {
        100: '#ffffff',
    },
})
